import * as saleConstant from './constants'

const initialState = {
  list: [],
  listNV: [],
  listKH: [],
  listEXP: [],
  item: {},
  type: saleConstant.SALE_REPORT_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  listNhomKh: []
}

const reducer = function productsReducer(state = initialState, action) {
  switch (action.type) {
    case saleConstant.SALE_REPORT_NVKD_REQUESTING:
      return {
        type: action.type,
      }

    case saleConstant.SALE_REPORT_NVKD_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listNV: action.data,
      }

    case saleConstant.SALE_REPORT_NVKD_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }
    case saleConstant.SALE_REPORT_KH_REQUESTING:
      return {
        type: action.type,
      }

    case saleConstant.SALE_REPORT_KH_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listKH: action.data,
      }

    case saleConstant.SALE_REPORT_KH_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }
    case saleConstant.SALE_REPORT_LIST_REQUESTING:
      return {
        list: [],
        item: {},
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Fetching data...!',
          time: new Date(),
        }],
        errors: [],
      }

    case saleConstant.SALE_REPORT_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        item: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case saleConstant.SALE_REPORT_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case saleConstant.SALE_REPORT_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        formData: action.payload,
        callback: action.callback,
      }

    case saleConstant.SALE_REPORT_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        listEXP: action.data,
      }

    case saleConstant.SALE_REPORT_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
      }

    case saleConstant.SALE_REPORT_NHOMKH_REQUESTING:
      return {
        type: action.type,
      }

    case saleConstant.SALE_REPORT_NHOMKH_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listNhomKh: action.data.records || [],
      }

    case saleConstant.SALE_REPORT_NHOMKH_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }

    case saleConstant.SALE_REPORT_KH_BY_NHOM_REQUESTING:
      return {
        type: action.type,
      }

    case saleConstant.SALE_REPORT_KH_BY_NHOM_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listKH: action.data || [],
      }

    case saleConstant.SALE_REPORT_KH_BY_NHOM_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Reports/SaleReport/reducer.js